import {
	TimereportItem,
	TimereportActivity,
	TimereportType,
	TimereportUserSettings,
	TimereportSubmitInfo,
	TimereportMonthStats,
	Holiday,
	TimereportWorkSchedule,
	TimereportReminder,
	TimereportVacationApplication,
} from '../Types/admin/timereport';
import {
	CreateTimereportRequest,
	UpdateTimereportRequest,
	SubmitTimereportsRequest,
	SubmitAllTimereportsResponse,
	CreateMonthReportsRequest,
	MonthReportSubmitRequest,
	UpdateOvertimeChoiceRequest,
	VacationApplicationRequest,
	VacationBalance,
} from '../Types/timereport';
import { TimereportLeaveSettings } from '../Types/admin/timereport';
import { get, getQSFromObject, httpDelete, post } from './common';

const endpoint = 'api/timereport';

// Time Reports CRUD
export const getTimereports = (start: string, end: string) =>
	get<TimereportItem[]>(`${endpoint}/GetTimereports?${getQSFromObject({ start, end })}`);

export const getAbsenceRequests = (start: string, end: string) =>
	get<TimereportItem[]>(`${endpoint}/GetAbsenceRequests?${getQSFromObject({ start, end })}`);

export const getTimereport = (id: number) =>
	get<TimereportItem>(`${endpoint}/GetTimereport?${getQSFromObject({ id })}`);

export const createTimereport = (data: CreateTimereportRequest) =>
	post<TimereportItem>(`${endpoint}/CreateTimereport`, data);

export const createLeaveTimereports = (data: CreateTimereportRequest[]) =>
	post<TimereportItem[]>(`${endpoint}/CreateLeaveTimereports`, data);

export const updateTimereport = (data: UpdateTimereportRequest) =>
	post<TimereportItem>(`${endpoint}/UpdateTimereport`, data);

export const deleteTimereport = (id: number) =>
	httpDelete(`${endpoint}/DeleteTimereport?${getQSFromObject({ id })}`);

// Activities
export const getActivities = () =>
	get<TimereportActivity[]>(`${endpoint}/GetActivities`);

export const getFavoriteActivities = () =>
	get<TimereportActivity[]>(`${endpoint}/GetFavoriteActivities`);

export const setFavoriteActivity = (projectId: number, activityId: number, isFavorite: boolean) =>
	post(`${endpoint}/SetFavoriteActivity?${getQSFromObject({ projectId, activityId, isFavorite })}`, {});

// Submission
export const submitTimereports = (data: SubmitTimereportsRequest) =>
	post(`${endpoint}/SubmitTimereports`, data);

export const submitAllTimereports = (upToDate: string) =>
	post<SubmitAllTimereportsResponse>(`${endpoint}/SubmitAllTimereports?${getQSFromObject({ upToDate })}`, {});

export const getSubmitInfo = (submitDate: string) =>
	get<TimereportSubmitInfo>(`${endpoint}/GetSubmitInfo?${getQSFromObject({ submitDate })}`);

export const createMonthReports = (data: CreateMonthReportsRequest) =>
	post(`${endpoint}/CreateMonthReports`, data);

export const submitWithMonthReport = (data: MonthReportSubmitRequest) =>
	post(`${endpoint}/SubmitWithMonthReport`, data);

export const updateMonthReportOvertimeChoice = (data: UpdateOvertimeChoiceRequest[]) =>
	post(`${endpoint}/UpdateMonthReportOvertimeChoice`, data);

export const attestTimereportEmployee = (id: number) =>
	post(`${endpoint}/AttestTimereportEmployee?${getQSFromObject({ id })}`, {});

// Holidays
export const getHolidays = () =>
	get<Holiday[]>(`${endpoint}/GetHolidays`);

// Timereport Types
export const getTimereportTypes = () =>
	get<TimereportType[]>(`${endpoint}/GetTimereportTypes`);

// Work Schedule
export const getWorkSchedule = () =>
	get<TimereportWorkSchedule | null>(`${endpoint}/GetWorkSchedule`);

// User Info
export const getUserInfo = () =>
	get<TimereportUserSettings>(`${endpoint}/GetUserInfo`);

export const updateFlag = (flagDate: string) =>
	post(`${endpoint}/UpdateFlag?${getQSFromObject({ flagDate })}`, {});

// Vacation
export const getVacationBalance = () =>
	get<VacationBalance>(`${endpoint}/GetVacationBalance`);

export const applyForVacation = (data: VacationApplicationRequest) =>
	post(`${endpoint}/ApplyForVacation`, data);

// Object Link
export const getTimereportsForObject = (objectType: string, objectId: number) =>
	get<TimereportItem[]>(`${endpoint}/GetTimereportsForObject?${getQSFromObject({ objectType, objectId })}`);

// Statistics (user's own data)
export const getMonthStats = (from: string, to: string) =>
	get<TimereportMonthStats[]>(`${endpoint}/GetMonthStats?${getQSFromObject({ from, to })}`);

export const getNormalizedHours = (from: string, to: string) =>
	get<{ normalizedHours: number }>(`${endpoint}/GetNormalizedHours?${getQSFromObject({ from, to })}`);
// Reminders
export const getReminders = () =>
	get<TimereportReminder[]>(`${endpoint}/GetReminders`);

// Vacation Applications
export const getVacationApplications = () =>
	get<TimereportVacationApplication[]>(`${endpoint}/GetVacationApplications`);

// Leave Settings
export const getLeaveSettings = () =>
	get<TimereportLeaveSettings>(`${endpoint}/GetLeaveSettings`);

export type AvailableLeaveBalance = Record<string, number>;

export const getAvailableLeaveBalance = () =>
	get<AvailableLeaveBalance>(`${endpoint}/GetAvailableLeaveBalance`);
